var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnehand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 14C21.8867 14 24.5 11.3867 24.5 8.16671C24.5 4.94671 21.8867 2.33337 18.6667 2.33337C15.4467 2.33337 12.8333 4.94671 12.8333 8.16671C12.8333 11.3867 15.4467 14 18.6667 14ZM25.025 20.5334C24.57 20.0667 23.9983 19.8334 23.3333 19.8334H15.1667L12.74 18.9817L13.125 17.885L15.1667 18.6667H18.4333C18.8417 18.6667 19.1683 18.5034 19.4367 18.235C19.705 17.9667 19.8333 17.64 19.8333 17.2784C19.8333 16.6484 19.53 16.2167 18.9233 15.9717L10.4417 12.8334H8.16668V23.3334L16.3333 25.6667L25.7017 22.1667C25.7133 21.5484 25.48 21 25.025 20.5334ZM5.83334 12.8334H1.14801V25.6667H5.83334V12.8334Z",
    fill: "#B28A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnehand);
export default __webpack_public_path__ + "static/media/onehand.539371656f3c95f4f0153b222a8696b5.svg";
export { ForwardRef as ReactComponent };